let decoration, base;

module.exports = function (d, b) {
  if (INKIVE.C.IS_MOBILE_APP) {
    base = b;
    decoration = d;

    const extension = {
      appBridge: require('./bridge')
    };

    _.each(decoration, processDecoratorMethod, extension);
    return b.extend
      ? b.extend(extension)
      : _.extend({}, b, extension);
  }

  return b;
};

function processDecoratorMethod (func, key) {
  const isCheckMethod = key.match(/Check$/) || key.match(/CheckOnce$/);

  if (!isCheckMethod) {
    const checkMethod = decoration[key + 'Check'];
    const checkOnceMethod = decoration[key + 'CheckOnce'];

    if (checkOnceMethod) {
      if (checkOnceMethod.call(this)) this[key] = func;
    } else if (checkMethod) {
      this[key] = _.partial(decoratedMethodWrapper, checkMethod, func, base.prototype[key]);
    } else {
      this[key] = func;
    }
  }
}

function decoratedMethodWrapper (checkFunc, appFunc, baseFunc) {
  const useAppFallback = checkFunc.call(this);

  useAppFallback && appFunc.apply(this, _.rest(arguments, 3));
  useAppFallback || (baseFunc && baseFunc.apply(this, _.rest(arguments, 3)));
}
